<template>
	<div class="c-panel c-panel--border c-panel--no-shadow margin-b-24">
		<h4 class="margin-b-24">Mijn locaties</h4>

		<div class="c-addressbook fs-xsmall">
			<div class="c-addressbook__item" v-for="address in getAdresses" :key="address.id">
				<div class="font-heading margin-b-8 fw-bold">{{address.name ? address.name : client_name}}</div>
				<div class="color-gray-600">
					{{ address.street }} {{address.number}}{{/^\d/.test(address.addition) ? '-' : ''}}{{address.addition}}<br />
					{{ address.zipcode }} {{ address.city }} <br />
					<a href="#" class="c-addressbook__link color-secondary" @click.prevent="changeAddres(address)" v-if="can('Adres wijzigen')">Wijzigen</a> /
					<a href="#" class="c-addressbook__link color-secondary" @click.prevent="deleteAddress(address.id)" v-if="can('Adres verwijderen')" >verwijderen</a>
				</div>
			</div>
		</div>

		<div v-if="hasMore" class="margin-b-24 text-center">
			<a href="#" class="c-addressbook__link color-secondary" @click.prevent="openModalShowAllAddresses()">Alle adressen tonen ({{addresses.length}})</a>
		</div>

        <c-splitbutton class="margin-b-24" :buttons="buttons" v-if="buttons.length > 0"></c-splitbutton>

        <c-show-all-addresses
			v-show="modalShowAllAddresses"
			size="medium"
			@close="modalShowAllAddresses = false"
			:addresses="this.addresses"
			:client_name="this.client_name"
			@delete="deleteAddress"
			@change="changeAddres">
		</c-show-all-addresses>

		<c-new-address v-if="changeAddress"
			:client_id="client_id"
			v-show="changeAddress"
			@close="changeAddress=false"
			@added="reload"
			size="medium"
			:edit="true"
			:address="address"/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import CShowAllAddresses from '@app/modals/ShowAllAddresses';
import CSplitbutton from '@components/Splitbutton';
import CNewAddress from '@app/modals/NewAddress'

export default {
	components: {
		CShowAllAddresses,
        CSplitbutton,
		CNewAddress
	},
	props: {
		addresses: {
			required: true,
			type: Array
		},
		client_name: {
			required: true
		},
		client_id: {
			requird: false,
			type: Number
		}
	},
	data() {
		return {
			max: 3,
			newestAddresses: '',
			modalShowAllAddresses: false,
			changeAddress: false,
			address: ''
		}
	},
	computed: {
		...mapGetters({
			can: 'user/can',
		}),
		getAdresses() {

			this.newestAddresses = this.addresses.slice(-this.max);
				return this.newestAddresses;
		},
		hasMore() {
			return this.addresses.length > this.max;
		},
        buttons() {
            const buttons = [];

            this.can('Adres aanmaken') && buttons.push({
                label: 'Adres toevoegen',
                action: () => {
                    this.trigger('new-address')
                },
            });

            this.can('Adres aanmaken') && buttons.push({
                label: 'Importeren',
                action: () => {
                    this.trigger('import-customer-addresses')
                },
            });

            return buttons;
        },
		...mapGetters({
			can: 'user/can',
		})
	},
	methods: {
		reload(){
			this.$emit('added');
		},
        trigger(event) {
           this.$store.dispatch('listener/emit', event);
		},
		openModalShowAllAddresses() {
			this.modalShowAllAddresses = true;
		},
		changeAddres(address){
			this.address = address;
			this.changeAddress = true;
		},
		deleteAddress(id){
			this.$xhr.delete('/api/addresses/' + id).then( ( {result}) => {
				this.$store.dispatch('toast/success', {title: 'Adres verwijderen', text: 'Adres is verwijderd'});
				this.$emit('added');
			}).catch( (e) => {
                    this.$store.dispatch('toast/alert', {title: 'Adres verwijderen', text: 'Er is helaas iets fout gegaan bij het verwijderen'});
			});
		}
    },

}
</script>
